import React, {useState, useEffect, useMemo} from "react";
import {useHistory} from "react-router-dom";
import moment from "moment";
import NavBar from "../../../utils/nav/NavBar";
import NavMenu from "../../../utils/nav/NavMenu";
import Loading from "../../../utils/loading";
import {GetPurchaseReceiptSummary} from "../../../../services/purchaseServices";
import {formatNumber} from "../../../../services/stringServices";
import {GetPrimerDiaDelMes} from "../../../../helpers/datesHelper";
import Authorization from "../../../utils/secure/Authorization";

import "../../../../css/purchase-receipt.css";

const PurchaseReceiptList = () => {
    const [permissionChecked, setPermissionChecked] = useState(false);
    const [loading, setLoading] = useState(false);
    const [desde, setDesde] = useState(moment(GetPrimerDiaDelMes()).format("YYYY-MM-DD"));
    const [hasta, setHasta] = useState(moment().format("YYYY-MM-DD"));
    const [data, setData] = useState([]);
    const [expandedDates, setExpandedDates] = useState({});

    const history = useHistory();

    useEffect(() => {
        const savedDesde = localStorage.getItem("purchaseReceiptList_desde");
        const savedHasta = localStorage.getItem("purchaseReceiptList_hasta");
        if (savedDesde) setDesde(savedDesde);
        if (savedHasta) setHasta(savedHasta);
    }, []);

    const cargar = async () => {
        try {
            console.log("Cargando",{desde, hasta});
            setLoading(true);
            localStorage.setItem("purchaseReceiptList_desde", desde);
            localStorage.setItem("purchaseReceiptList_hasta", hasta);
            const response = await GetPurchaseReceiptSummary(desde, hasta);
            setData(response);
            console.log("Cargar",{desde, hasta});
        } catch (error) {
            alert("Error al cargar el resumen: " + error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (permissionChecked) {
            cargar();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [permissionChecked]);

    const groupedData = useMemo(() => {
        const groups = {};
        data.forEach(item => {
            const dateKey = moment(item.fecha).format("YYYY-MM-DD");
            if (!groups[dateKey]) {
                groups[dateKey] = {
                    fecha: item.fecha,
                    total: 0,
                    providers: []
                };
            }
            groups[dateKey].total += item.importeSurtido;
            groups[dateKey].providers.push(item);
        });
        return Object.values(groups).sort((a, b) => moment(b.fecha).diff(moment(a.fecha)));
    }, [data]);

    const totalGeneral = useMemo(() => {
        return groupedData.reduce((acc, group) => acc + group.total, 0);
    }, [groupedData]);

    const toggleExpand = (dateKey) => {
        setExpandedDates(prev => ({
            ...prev,
            [dateKey]: !prev[dateKey]
        }));
    };

    const handleDateClick = (fecha) => {
        history.push(`/purchase-receipt?fecha=${moment(fecha).format("YYYY-MM-DD")}`);
    };

    return (
        <div id="purchase-receipt-list">
            {!permissionChecked && (
                <Authorization
                    permission="Compras/RecepcionCompra/Resumen"
                    onPermissionGranted={() => setPermissionChecked(true)}
                />
            )}
            <div className="page-header">
                <NavBar
                    title="Resumen de Compras"
                    navButtonComponent={<NavMenu/>}
                />

                <div className="bar single filters"
                     style={{padding: "10px", display: "flex", flexDirection:"row", gap: "10px", alignItems: "center", flexWrap: "wrap"}}>
                    <div className="filter-item">
                        <label style={{display: "block", fontSize: "0.8rem"}}>Desde:</label>
                        <input
                            type="date"
                            value={desde}
                            onChange={(e) => setDesde(e.target.value)}
                            className="form-control"
                        />
                    </div>
                    <div className="filter-item">
                        <label style={{display: "block", fontSize: "0.8rem"}}>Hasta:</label>
                        <input
                            type="date"
                            value={hasta}
                            onChange={(e) => setHasta(e.target.value)}
                            className="form-control"
                        />
                    </div>
                    <button
                        className="btn btn-primary"
                        onClick={cargar}
                        style={{marginTop: "auto"}}
                    >
                        Cargar
                    </button>
                </div>

            </div>

            <Loading show={loading}/>

            <div className="list-container" style={{padding: "10px"}}>
                {groupedData.map((group) => {
                    const dateKey = moment(group.fecha).format("YYYY-MM-DD");
                    const isExpanded = expandedDates[dateKey];
                    return (
                        <div key={dateKey} className="group-item"
                             style={{marginBottom: "10px", borderBottom: "1px solid #ddd", paddingBottom: "5px"}}>
                            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                <div
                                    onClick={() => handleDateClick(group.fecha)}
                                    style={{
                                        cursor: "pointer",
                                        color: "#007bff",
                                        fontWeight: "bold",
                                        fontSize: "1.1rem"
                                    }}
                                >
                                    {moment(group.fecha).format("DD/MM/yy")}
                                </div>
                                <div style={{display: "flex", alignItems: "center", gap: "10px"}}>
                                    <span style={{fontWeight: "bold"}}>
                                        {formatNumber(group.total, 2)}
                                    </span>
                                    <button
                                        className="btn btn-primary btn-sm"
                                        onClick={() => toggleExpand(dateKey)}                                        
                                    >
                                        <i className={`fas ${isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                                    </button>
                                </div>
                            </div>
                            {isExpanded && (
                                <div className="details"
                                     style={{marginTop: "5px", paddingLeft: "15px", fontSize: "1.2rem", color: "#555"}}>
                                    {group.providers.map((p, idx) => (
                                        <div key={idx} style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            padding: "5px 10px",
                                            backgroundColor: idx % 2 === 0 ? "transparent" : "#f9f9f9"
                                        }}>
                                            <span>{p.proveedor}</span>
                                            <span>{formatNumber(p.importeSurtido, 2)}</span>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    );
                })}

                {groupedData.length > 0 && (
                    <div className="total-general" style={{
                        marginTop: "20px",
                        padding: "10px",
                        borderTop: "2px solid #333",
                        display: "flex",
                        justifyContent: "space-between",
                        fontWeight: "bold",
                        fontSize: "1.2rem"
                    }}>
                        <span>TOTAL</span>
                        <span>{formatNumber(totalGeneral, 2)}</span>
                    </div>
                )}

                {!loading && groupedData.length === 0 && (
                    <div style={{textAlign: "center", marginTop: "20px"}}>No hay datos para el rango seleccionado.</div>
                )}
            </div>
        </div>
    );
};

export default PurchaseReceiptList;